import { useForm } from "react-hook-form";
import { Box, Button, FormControl, FormLabel, TextField, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { manualAdjustLinkedinDeal, manualAdjustLinkedinDealReset } from "../../state/linkedinPromotion/linkedinPromotionSlice";
import { selectLinkedinPromotionState } from "../../state/linkedinPromotion/linkedinPromotionSelector";

const LinkedinManualAdjustModal = ({ onClose, companyInfo }) => {
  const dispatch = useDispatch();
  const { isManualAdjusting, isManualAdjustSuccess } = useSelector(selectLinkedinPromotionState);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: { amount: "" } });

  // Close modal on success
  useEffect(() => {
    if (isManualAdjustSuccess) {
      dispatch(manualAdjustLinkedinDealReset());
      reset();
      onClose();
    }
  }, [isManualAdjustSuccess, dispatch, onClose, reset]);

  const onSubmit = (data) => {
    if (companyInfo?.id) {
      dispatch(
        manualAdjustLinkedinDeal({
          companyId: companyInfo.id,
          amount: data.amount,
        })
      );
    }
  };

  return (
    <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)} sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
      <FormControl fullWidth>
        <FormLabel sx={{ mb: 1 }}>Amount to Charge</FormLabel>
        <TextField
          size="small"
          type="number"
          {...register("amount", {
            valueAsNumber: true,
            required: "Amount is required",
            min: { value: 1, message: "Must be greater than 0" },
          })}
          error={!!errors.amount}
          helperText={errors.amount?.message}
          placeholder="e.g. 50"
        />
      </FormControl>

      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit" fullWidth disabled={isManualAdjusting}>
          Cancel
        </Button>
        <Button type="submit" variant="contained" fullWidth disabled={isManualAdjusting}>
          {isManualAdjusting ? "Processing..." : "Charge & Generate Invoice"}
        </Button>
      </Stack>
    </Box>
  );
};

export default LinkedinManualAdjustModal;
